import useObservableValue from "../../../Hooks/useObservableValue";
import { DayTheme, NightTheme } from "../Config/Theme";
import theme$ from "../Observables/theme$";
import { THEME_TYPE } from "../Types/CommonTypes";
import { mergeThemes } from "../Utils/helpers";

function useThemeValue(overridingTheme?: Partial<THEME_TYPE>): THEME_TYPE {
  const appTheme = useObservableValue(theme$);
  return mergeThemes(appTheme, overridingTheme ?? {});
}

export default useThemeValue;

export const getThemeValue = () => theme$.getValue();

export const setThemeValue = (theme: THEME_TYPE) => theme$.next(theme);

export const toggleTheme = () => {
  const { type } = getThemeValue();
  console.log(type);
  theme$.next(type === "dark" ? DayTheme : NightTheme);
};
